import { z } from 'zod'

import { HouseShipmentSchema } from '../domain/houseShipment.ts'
import { OverviewItem, OverviewItemSchema } from '../domain/overviewItem.ts'
import { CustomerHouseShipmentResponse } from '../types.ts'
import {
  getDelayDays,
  getPlaceOfDeliveryNode,
  getPlaceOfPickupNode,
  getTimelineData,
} from '../utils/getTimelineData.ts'

export const shipmentV2ToOverviewItem = (shipment: CustomerHouseShipmentResponse): OverviewItem | undefined => {
  try {
    const houseShipment = HouseShipmentSchema.parse(shipment)
    const parsingObj = {
      id: houseShipment.code,
      type: 'shipment',
      transportMode: houseShipment.details.mainTransportMode,
      transportType: houseShipment.details.mainTransportType,
      containerQuantity: houseShipment.houseCargos.length,
      state: houseShipment.status,
      bookedDate: houseShipment.details.bookedAt,
      createdDate: houseShipment.sys.createdAt,
      deliveryDate: getPlaceOfDeliveryNode(houseShipment)?.milestones.timeOfArrival?.timeStampUTC,
      pickupDate: getPlaceOfPickupNode(houseShipment)?.milestones.timeOfDeparture?.timeStampUTC,
      timeline: getTimelineData(houseShipment),
      containerPlans: [], // do not have
      customerReference: houseShipment.details.customerReference || '',
      shipper: houseShipment.contacts.shipperContactName || '',
      cargo: [], // deprecated by houseCargos
      houseCargos: houseShipment.houseCargos,
      delayDays: getDelayDays(houseShipment),
    }

    return OverviewItemSchema.parse(parsingObj)
  } catch (error) {
    /* eslint-disable no-console */
    if (error instanceof z.ZodError) {
      console.error(`ZOD Error in shipmentV2ToOverviewItem: ${shipment.code}`, error.issues)
    } else {
      console.error(`Error in shipmentV2ToOverviewItem: ${shipment.code}`, error)
    }
  }
}
